
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSleetShowersDay as ObiSleetShowersDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sleet-showers-day.js';
 
 
 

 
 export const ObiSleetShowersDay = createComponent({
   react: React,
   tagName: 'obi-sleet-showers-day',
   elementClass: ObiSleetShowersDayElement,
   events: {
     
   }
  });
 
 